(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 767.98px)').matches;
  }

  function closeItem(item) {
    var button = item.querySelector('[data-sa-toggle]');
    if (!button) return;
    item.classList.remove('is-open');
    button.setAttribute('aria-expanded', 'false');
  }

  function openItem(item) {
    var button = item.querySelector('[data-sa-toggle]');
    if (!button) return;
    item.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
  }

  function syncExpandedState(section) {
    section.querySelectorAll('.simple-accordion__item').forEach(function (item) {
      var button = item.querySelector('[data-sa-toggle]');
      if (!button) return;
      if (isMobile()) {
        button.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      } else {
        button.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function initSection(section) {
    if (!section || section.dataset.saReady === 'true') return;
    section.dataset.saReady = 'true';

    var items = Array.from(section.querySelectorAll('.simple-accordion__item'));
    if (!items.length) return;

    items.forEach(function (item) {
      var button = item.querySelector('[data-sa-toggle]');
      if (!button) return;

      button.addEventListener('click', function () {
        if (!isMobile()) return;
        var isOpen = item.classList.contains('is-open');
        items.forEach(closeItem);
        if (!isOpen) openItem(item);
      });
    });

    syncExpandedState(section);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-simple-accordion]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector
      ? event.target.querySelector('[data-simple-accordion]')
      : null;
    if (!section && event.target.hasAttribute && event.target.hasAttribute('data-simple-accordion')) {
      section = event.target;
    }
    if (!section) return;
    section.dataset.saReady = '';
    initSection(section);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest ? event.target.closest('.simple-accordion__item') : null;
    if (!item || !isMobile()) return;
    var section = item.closest('[data-simple-accordion]');
    if (!section) return;
    section.querySelectorAll('.simple-accordion__item').forEach(closeItem);
    openItem(item);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-simple-accordion]').forEach(syncExpandedState);
  });
})();
